/**
 * FRONTEND MONITORING ABSTRACTION
 */
import { provider } from './providers/sentry';

export const initMonitor = provider.init;

export const Monitor = {
  captureError: provider.captureError,
  captureMessage: provider.captureMessage,
  ErrorBoundary: provider.ErrorBoundary,
};
